import React from 'react';
import styled from 'styled-components';
export const NotFound = () => {
    return (React.createElement(SContainer, null,
        React.createElement("div", { style: {
                padding: 4,
            } },
            React.createElement("h1", null, "NotFound"))));
};
const SContainer = styled.div `
  text-align: center;
`;
